import React from "react";
import styles from "./SignalAndDataFlows.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import * as appConfig from "appConfig";
import { messages } from "../Workflow.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const SignalAndDataFlows: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs>
        {[
          <div key={1} className={styles.carouselItem}>
            <img
              className={styles.image}
              src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/workflow/1.png`}
              alt="feature-comparison"
            />
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.signalAndDataFlowsTitle)}</h3>
            <ui.Scrollbars>
              <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.signalAndDataFlowsDescription) }}></p>
            </ui.Scrollbars>
          </div>,
        ]}
      </SpatialCarousel>
    </div>
  );
};
